import { render, staticRenderFns } from "./NomineeResume.html?vue&type=template&id=c488e70a&scoped=true&external"
import script from "./NomineeResume.vue?vue&type=script&lang=js"
export * from "./NomineeResume.vue?vue&type=script&lang=js"
import style0 from "./NomineeResume.scss?vue&type=style&index=0&id=c488e70a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c488e70a",
  null
  
)

export default component.exports